module.exports = __webpack_public_path__ + "img/guizhouHints_23.a06278f5.jpg";